import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TrAutoCompleteComponent } from './tr-autocomplete.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TypeaheadModule.forRoot(),
    ],
    exports: [ TrAutoCompleteComponent ],
    declarations: [ TrAutoCompleteComponent ],
})
export class TrAutocompleteModule {}
